/*
 * Copyright (c) 2025 Hardfin, Inc.
 */
import { TicketCategory } from '@/ticket/api/types';

interface CategoryOptions {
  id: TicketCategory;
  label: string;
}

export const categories: Record<TicketCategory, CategoryOptions> = {
  TODO: {
    id: 'TODO',
    label: 'To Do',
  },
  CHECK: {
    id: 'CHECK',
    label: 'Check',
  },
  DEFECT: {
    id: 'DEFECT',
    label: 'Defect',
  },
  REPAIR: {
    id: 'REPAIR',
    label: 'Repair',
  },
  MISC: {
    id: 'MISC',
    label: 'Miscellaneous',
  },
};
